<template>
  <div class="navbar__actions">
    <ul class="navbar__links-list">
      <li
        v-for="link in filteredActionLinks"
        :key="link.id"
        @click="linkClickHandler(link.value)"
        :class="{ bordered: link.value === 'change-log' }"
      >
        <div
          class="navbar__links-list__item"
          v-if="link.value !== 'user-roles' && link.value !== 'proposal'"
        >
          <el-tooltip
            :open-delay="1000"
            :content="$t(link.value)"
            placement="bottom"
          >
            <r-icon :name="link.icon" :size="24" />
          </el-tooltip>
          <!-- <div
            v-if="link.value === 'change-log' && notifications"
            class="active-tasks-count change-log"
          /> -->
        </div>
        <div class="navbar__links-list__item" v-else>
          <el-tooltip
            :open-delay="1000"
            :content="$t(link.value)"
            placement="bottom"
          >
            <router-link
              :class="{ active: $route.path == link.to, navbar__link: true }"
              :to="link.to"
            >
              <r-icon
                :name="link.icon"
                :size="24"
                :color="$route.path === link.to ? 'white' : undefined"
              />
            </router-link>
          </el-tooltip>
        </div>
      </li>
    </ul>
    <el-tooltip :open-delay="1000" :content="$t('tasks')" placement="bottom">
      <el-popover
        placement="bottom-end"
        width="330"
        :title="$t('tasks.active-tasks::list')"
        :popper-class="`popover-tasks`"
        :visible-arrow="false"
        v-model="taskPopover"
      >
        <tasks @toggleSortTree="toggleTaskPopover" />
        <div slot="reference" class="navbar__actions-icon">
          <div class="navbar__links-list__item">
            <r-icon name="tasks" :size="24" />
            <div v-if="activeTasks" class="active-tasks-count">
              <span>{{ activeTasks }}</span>
            </div>
          </div>
        </div>
      </el-popover>
    </el-tooltip>
    <account-menu />
  </div>
</template>

<script>
import accountMenu from "./account-menu";
import tasks from "@/components/tasks/tasks";
import { actionLinks } from "../config/";

export default {
  components: {
    accountMenu,
    tasks
  },
  data() {
    return {
      taskPopover: false,
      notifications: true,
      actionLinks
    };
  },
  computed: {
    isAdmin() {
      return this.$store.state.admin;
    },
    isLocalAdmin() {
      return this.$store.state.local_admin;
    },
    instance() {
      return this.$store.state.instance;
    },
    hasDemoRequest() {
      return this.$store.state.settings
        ? this.$store.state.settings.demo_request
        : false;
    },
    filteredActionLinks() {
      const links = this.actionLinks[this.instance] || this.actionLinks.default;
      return links.filter(l => {
        switch (l.name) {
          case "UserRoles":
            return this.isAdmin || this.isLocalAdmin;
          case "Proposal":
            console.log(this.hasDemoRequest);
            return this.hasDemoRequest && this.isAdmin;
          default:
            return true;
        }
      });
    },
    activeTasks() {
      return this.$store.state.activeTasks.length;
    }
  },
  methods: {
    hasModule(name) {
      return this.$store.getters.hasModule(name);
    },
    toggleTaskPopover() {
      this.taskPopover = !this.taskPopover;
    },
    openWindow(title) {
      const options = { title, type: title };

      this.$store.commit("ADD_NEW_OVERHEAD_WINDOW", options);
      this.$store.dispatch("SAVE_MAIN_USER_CONFIG");
    },
    openModalBox(val) {
      this.$store.commit("OPEN_MODAL_WINDOW", val);
    },
    linkClickHandler(type) {
      switch (type) {
        case "ds-manager":
        case "change-log":
        case "ds-manager-new":
          this.openModalBox(type);
          break;
      }
    }
  }
};
</script>

<style lang="scss">
.navbar__actions {
  display: flex;
  align-items: center;
  margin-right: 15px;
  height: 100%;
  margin-left: auto;
  li {
    cursor: pointer;
    height: 100%;
    display: flex;
    justify-content: center;
    margin-right: 16px;
    &:last-child {
      margin-right: 16px;
    }
    &.bordered {
      width: 64px;
      border-left: 1px solid;
      border-right: 1px solid;
      border-color: var(--dividers_low_contrast) !important;
    }
    a:hover {
      border: none !important;
    }
  }
  .navbar__links-list__item {
    width: 32px;
    height: 32px;
    box-sizing: border-box;
    border-radius: var(--border-radius);
    .el-tooltip {
      margin-right: 0;
    }
    &:hover {
      background-color: var(--accent_selected) !important;
    }
  }
  &-icon {
    height: 100%;
    display: flex;
    box-sizing: border-box;
    width: 32px;
    margin-right: 1px;
    cursor: pointer;
    position: relative;
    &:last-child {
      margin-right: 0;
    }
  }
  .el-tooltip {
    margin-right: 16px;
  }
}
.active-tasks-count {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: absolute;
  top: 5px;
  right: 0;
  background-color: var(--accent_success) !important;
  span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 10px;
    color: var(--white_white) !important;
  }
  &.change-log {
    width: 8px;
    height: 8px;
    top: 4px;
    right: 16px;
    background-color: var(--accent_error) !important;
  }
}
</style>

<i18n>
{
  "ru": {
    "user-roles": "Роли и разрешения",
    "proposal": "Заявки на демо-доступ",
    "change-log": "Обновления",
    "ds-manager": "Менеджер ИД",
    "tasks": "Активные задачи",
    "tasks.active-tasks::list": "Список активных задач"
  },
  "en": {
    "user-roles": "Users&Roles",
    "proposal": "Demo-access proposals",
    "change-log": "Updates",
    "ds-manager": "DS manager",
    "tasks": "Active tasks",
    "tasks.active-tasks::list": "Active tasks list"
  }
}
</i18n>
